<template>
  <div>
    <div class="product-window" :class="attr.cartAttr === true ? 'on' : ''">
      <div class="textpic acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="attr.productSelect.image" class="image" />
        </div>
        <div class="text">
          <div class="line1">
            {{ attr.productSelect.store_name }}
          </div>
          <div class="money font-color-red">
            ￥<span class="num">{{ attr.productSelect.price }}</span
            ><span class="stock">库存: {{ attr.productSelect.stock }}</span>
          </div>
        </div>
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>
      <div class="productWinList">
        <div
          class="item"
          v-for="(item, indexw) in attr.productAttr"
          :key="indexw"
        >
          <div class="title">{{ item.attr_name }}</div>
          <div class="listn acea-row row-middle">
            <div
              class="itemn"
              :class="item.index === indexn ? 'on' : ''"
              v-for="(itemn, indexn) in item.attr_value"
              @click="tapAttr(indexw, indexn)"
              :key="indexn"
            >
              {{ itemn.attr }}
            </div>
          </div>
        </div>
      </div>
      <div class="cart">
        <div class="title">数量</div>
        
        <div class="carnum acea-row row-left">
          <div
            class="item reduce"
            :class="attr.productSelect.cart_num <= 1 ? 'on' : ''"
            @click="CartNumDes"
          >
            -
          </div>
          <div class="item num">{{ attr.productSelect.cart_num }}</div>
          <div
            class="item plus"
            :class="
              attr.productSelect.cart_num >= attr.productSelect.stock
                ? 'on'
                : ''
            "
            @click="CartNumAdd"
          >
            +
          </div>
        </div>
        
        <div class=" acea-row row-left dpmt" v-if="cate.is_autonumber">
             不清楚需要多少块？输入吊顶区域自动计算，单位m
           </div>
        <div class=" acea-row row-left dpmt" v-if="cate.is_autonumber"> 
             <input
                type="text"
                placeholder="输入长度"
                v-model="width"
                class="dpinput"
              />
              <div
            class="dpreduce" 
          >
            -
          </div>
              <input
                type="text"
                placeholder="输入宽度"
                v-model="height"
                class="dpinput"
              />
               <div
            class="dpreduce" 
          >
            -
          </div>
           <input
                type="text"
                placeholder="灯位数量"
                v-model="dengwei"
                class="dpinput"
              />
               
              <div class="dpbtn" @click="JiSuan">计算</div>
        </div>
     

      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      :hidden="attr.cartAttr === false"
      @click="closeAttr"
    ></div>
  </div>
</template>
<script>
export default {
  name: "ProductWindow",
  props: {
    attr: {
      type: Object,
      default: () => {}
    },
    cate:{
      type:Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      mianji:0,
      width:'',
      height:'',
      dengwei:''
    };
  },
  mounted: function() {
    console.log(this.cate);
    },
  methods: {
    closeAttr: function() {
      this.$emit("changeFun", { action: "changeattr", value: false });
    },
    CartNumDes: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: false });
    },
    CartNumAdd: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: 1 });
    },
    JiSuan:function(){
      let xinghao=this.cate.cate.cate_name;
      if(xinghao.indexOf("*")!=-1){
         let pro_width=xinghao.split('*')[0];
         let pro_height=xinghao.split('*')[1];
         let pro_width_start=4;  //小于等于这个数就忽略
         let pro_height_start=4;  //小于等于这个数就忽略
         let pro_width_half=pro_width/2;  //半数
         let pro_height_half=pro_height/2; //半数
  
         let width=Math.round(this.width*100)  //转换成厘米
         let height=Math.round(this.height*100) //转换成厘米
         let dengwei=this.dengwei;

         console.log("产品长"+pro_width)
         console.log("产品宽"+pro_height)
         console.log("用户输入长"+width)
         console.log("用户输入宽"+height)
         console.log("用户输入灯位"+dengwei)
         if(width>0&&height>0){
            let width_result=0;
            let width_y=width%pro_width;
            console.log("长的余数是"+width_y)
            if(width_y<=pro_width_start){
              width_result=Math.floor(width/pro_width);
            }else if(width_y<=pro_width_half){
              width_result=Math.floor(width/pro_width)+0.5;
            }else{
              width_result=Math.floor(width/pro_width)+1;
            }
            console.log("长的计算结果："+width_result);

            let height_result=0;
            let height_y=height%pro_height;
            console.log("宽的余数是"+height_y)
            if(height_y<=pro_height_start){
              height_result=Math.floor(height/pro_height);
            }else if(height_y<=pro_height_half){
              height_result=Math.floor(height/pro_height)+0.5;
            }else{
              height_result=Math.floor(height/pro_height)+1;
            }
            
            console.log("宽的计算结果："+height_result);
            let result=Math.round(width_result*height_result)-dengwei;
            console.log("计算数量："+result);
            this.$emit("changeFun", { action: "setCartNum", value: result });
          }else{
            console.log("请输入正确的长宽");
            return;
          }
      }else{
        console.log("参数错误，cate_name不是长*宽的格式");
      }
       
    },
    tapAttr: function(indexw, indexn) {
      let that = this;
      that.attr.productAttr[indexw].index = indexn;
      let value = that
        .getCheckedValue()
        .sort()
        .join(",");
      that.$emit("changeFun", { action: "ChangeAttr", value: value });
    },
    //获取被选中属性；
    getCheckedValue: function() {
      let productAttr = this.attr.productAttr;
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        for (let j = 0; j < productAttr[i].attr_values.length; j++) {
          if (productAttr[i].index === j) {
            value.push(productAttr[i].attr_values[j]);
          }
        }
      }
      return value;
    }
  }
};
</script>
<style scoped>
.dpinput{ border:1px solid #a4a4a4; width:1.3rem; height:0.5rem; padding:0 0.1rem; line-height:0.54rem; font-size:0.28rem}
.dpmt{ margin-top:0.2rem;}
.dpbtn{border-radius: 0 0.06rem 0.06rem 0;
    line-height: 0.46rem; border: 1px solid #a4a4a4;
    width: 0.84rem;
    text-align: center;
    height: 0.5rem;
    line-height: 0.5rem;
    color: #a4a4a4;
    font-size: 0.25rem; margin-left:.2rem}
  .dpreduce{ height:0.5rem;line-height:0.35rem; padding:0 0.1rem;}
</style>